import { DatiqCellHeaderSortBy } from './datiq-cell-header-sort.enum';
import { IDatiqCellHeaderSort } from './datiq-cell-header-sort.interface';
import {
    datiqInputCreateId,
    DATIQ_DEFAULT_EMPTY_LABEL,
    DATIQ_INPUT_TOGGLE,
} from '@dat/datiq-core/models';

export const emptyDatiqCellHeaderSort: IDatiqCellHeaderSort = {
    label: DATIQ_DEFAULT_EMPTY_LABEL,
    sortBy: DatiqCellHeaderSortBy.None,
    longHeader: false,
};

export const DATIQ_TOGGLE_ID: (id: string) => string = (id: string) =>
    datiqInputCreateId([id, DATIQ_INPUT_TOGGLE, 'selected']);
